import {useState} from 'react';
import styles from './createGroup.module.scss';
import backIcon from 'images/back.png';
import UploadImage from 'components/Startup/profile/companyImage';
import {Form, Input, Select, Spin, Switch} from 'antd';
import {useNavigate} from 'react-router-dom';
import {useMutation, useQuery} from '@apollo/client';
import {GET_ALL_TOPICS} from 'graphql/queries/investorUpdates';
import {CREATE_GROUP} from 'graphql/mutations/groups';
import SubmitButton from 'components/Startup/components/SubmitButton';
import {GET_ALL_GROUPS} from 'graphql/queries/groups';
import {toast} from 'react-toastify';
import {UserSelectField} from 'components/userSelectField/UserSelectField';

const CreateGroup = () => {
  const [imgUrl, setImgUrl] = useState('');
  const [previewUrl, setPreviewUrl] = useState('');
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [welcomeMessage, setWelcomeMessage] = useState('');
  const [privacy, setPrivacy] = useState([]);
  const [admin, setAdmin] = useState([]);
  const [moderator, setModerator] = useState([]);
  const [interests, setInterests] = useState([]);
  const [allowDocumentUpload, setAllowDocumentUpload] = useState({
    admins: false,
    moderators: false,
    nonAdmins: false,
  });
  const [allowDownload, setAllowDownload] = useState({
    admins: false,
    moderators: false,
    nonAdmins: false,
  });
  const [allowScreenRecord, setAllowScreenRecord] = useState({
    admins: false,
    moderators: false,
    nonAdmins: false,
  });
  const [allowSendMessages, setAllowSendMessages] = useState({
    admins: false,
    moderators: false,
    nonAdmins: false,
  });
  const navigate = useNavigate();
  const {Option} = Select;
  const {TextArea} = Input;
  const width = 732;

  const {data, loading} = useQuery(GET_ALL_TOPICS);
  const [createGroup, {loading: loadingGroup}] = useMutation(CREATE_GROUP);

  const handleCreateGroup = () => {
    createGroup({
      variables: {
        data: {
          bannerImg: imgUrl,
          description,
          name,
          welcomeMessage,
          admins: admin.map(data => data.split(';')[2]),
          moderators: moderator.map(data => data.split(';')[2]),
          topics: interests?.map(data => data.split(';')[1]),
          isPrivate: privacy === 'PRIVATE',
          settings: {
            allowDocumentUpload,
            allowDownload,
            allowScreenRecord,
            allowSendMessages,
          },
        },
      },
      refetchQueries: [{query: GET_ALL_GROUPS}],
    }).then(({data: {createGroup}}) => {
      if (createGroup.__typename === 'Error') {
        toast.error(createGroup.message);
      } else {
        toast.success('Created Successfully');
        navigate('/dashboard/groups');
      }
    });
  };

  if (loading) {
    return (
      <div className={styles.loading}>
        <Spin size="large" />
        <h1>Loading...</h1>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <img onClick={() => navigate(-1)} src={backIcon} alt="" />
        <h1 className={styles['h-style']}>Circles / </h1>
        <span>New Circle</span>
      </div>
      <div className={styles['main-content']}>
        <h1>Image</h1>
        <UploadImage
          previewUrl={previewUrl}
          setPreviewUrl={setPreviewUrl}
          setImgUrl={setImgUrl}
          bucket={'group-images-bucket'}
          accept="image/*"
          large
        />
        <Form
          onFinish={handleCreateGroup}
          className={styles.form}
          layout="vertical">
          <Form.Item
            name="name"
            label="Name"
            rules={[
              {
                required: true,
                message: 'Name of group required',
              },
            ]}>
            <Input
              onChange={e => setName(e.target.value)}
              value={name}
              style={{width}}
              placeholder="Name of group"
            />
          </Form.Item>
          <Form.Item
            name="privacy"
            label="Privacy"
            rules={[
              {
                required: true,
                message: 'Name of group required',
              },
            ]}>
            <Select
              value={privacy}
              onChange={e => setPrivacy(e)}
              style={{width}}>
              <Option value="PUBLIC">Public</Option>
              <Option value="PRIVATE">Private</Option>
            </Select>
          </Form.Item>
          <Form.Item
            name="description"
            rules={[
              {
                required: true,
                message: 'Description of group required',
              },
            ]}
            label="Description">
            <TextArea
              style={{width}}
              value={description}
              onChange={e => setDescription(e.target.value)}
              placeholder="Group Description"
              rows={4}
            />
          </Form.Item>
          <Form.Item
            name="welcomeMessage"
            rules={[
              {
                required: true,
                message: 'Welcome Message is required',
              },
            ]}
            label="Welcome Message">
            <TextArea
              style={{width}}
              value={welcomeMessage}
              onChange={e => setWelcomeMessage(e.target.value)}
              placeholder="Group Welcome Message"
              rows={4}
            />
          </Form.Item>
          <Form.Item name="interests" label="Interests">
            <Select
              onChange={e => setInterests(e)}
              style={{width}}
              value={interests}
              placeholder="Select Interests"
              mode="multiple">
              {data?.getAllTopics?.map(({name, icon, id}) => (
                <Option key={`${name};${id}`}>
                  <div className={styles['all-data']}>
                    <img src={icon} alt="" />
                    <span>{name}</span>
                  </div>
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item className={styles.width} label="Select Admin" name="admin">
            <UserSelectField users={admin} setUsers={setAdmin} />
          </Form.Item>
          <Form.Item
            className={styles.width}
            label="Select Moderator"
            name="moderator">
            <UserSelectField users={moderator} setUsers={setModerator} />
          </Form.Item>
          <div>
            <h1 className={styles['header-text']}>Group Settings</h1>
          </div>
          <div className={styles.settingsWrap}>
            {[
              {
                title: 'Allow Document Upload',
                state: allowDocumentUpload,
                setState: setAllowDocumentUpload,
                prefix: 'allowUpload',
              },
              {
                title: 'Allow Downloads',
                state: allowDownload,
                setState: setAllowDownload,
                prefix: 'allowDownload',
              },
              {
                title: 'Allow Screen Record',
                state: allowScreenRecord,
                setState: setAllowScreenRecord,
                prefix: 'allowRecord',
              },
              {
                title: 'Allow Send Messages',
                state: allowSendMessages,
                setState: setAllowSendMessages,
                prefix: 'allowSend',
              },
            ].map(section => (
              <div key={section.title} className={styles.settingsCard}>
                <h3 className={styles['header-subtext']}>{section.title}</h3>
                <div className={styles.settingsGrid}>
                  {[
                    {key: 'admins', label: 'Admins'},
                    {key: 'moderators', label: 'Moderators'},
                    {key: 'nonAdmins', label: 'Members'},
                  ].map(role => (
                    <Form.Item
                      key={`${section.prefix}-${role.key}`}
                      name={`${section.prefix}${role.key
                        .slice(0, 1)
                        .toUpperCase()}${role.key.slice(1)}`}
                      label={role.label}
                      valuePropName="checked">
                      <Switch
                        checked={section.state[role.key]}
                        onChange={checked =>
                          section.setState({
                            ...section.state,
                            [role.key]: checked,
                          })
                        }
                      />
                    </Form.Item>
                  ))}
                </div>
              </div>
            ))}
          </div>
          <SubmitButton label="Create Circle" disabled={loadingGroup} />
        </Form>
      </div>
    </div>
  );
};

export default CreateGroup;
